import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('partPopupStore', Object.keys(getters)),
	...mapState('partPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('partPopupStore', Object.keys(actions)),
	...mapMutations('partPopupStore', Object.keys(mutations))
};
